/*
 * Helper functions that relate to Mixpanel
 */
define('mixpanel-helper',['require','lodash'],function (require) {
    var _ = require('lodash');
    var superPropertiesLoaded = false;
    var eventQueue = [];

    /**
     * Returns another function with the proper execution context saved in, so that it can be called later.
     * @returns {Function}
     * @private
     */
    function _queueFnCall(fn) {
        if (superPropertiesLoaded) {
            fn();
        } else {
            eventQueue.push(fn);
        }
    }

    return {
        /**
         * Fire mixpanel events added to the event queue after super properties have been loaded.
         */
        onSuperPropertiesLoad: function () {
            superPropertiesLoaded = true;

            while (eventQueue.length) {
                (eventQueue.shift())();
            }
        },

        /*
         * Usual Mixpanel tracking. Returns true so Knockout doesn't block the href.
         * Use with links that should open in a new window.
         * <a href="example.com" target="_blank" data-bind="on.click(track('Example'))">Example</a>
         */
        track: function (name, properties) {
            _queueFnCall(window.mixpanel.track.bind(window.mixpanel, name, properties));
            return true;
        },
        /*
         * Tries to ensure Mixpanel tracking is sent before a page redirect.
         * If desirable, use alongside href to preserve <a> tag behaviors. Some <a> actions, such
         * as "Open a new tab" will not be tracked with a vanilla click event.
         * Use in place of the Mixpanel track_links method which does not work correctly
         */
        trackLink: function (url, name, properties) {
            _queueFnCall(function () {
                window.mixpanel.track(name, properties, function () {
                    window.location.href = url;
                });

                setTimeout(function () {
                    window.location.href = url;
                }, 700);
            });
            return false;   // Prevent default href redirect
        },

        trackLinkNewTab: function (url, name, properties, isSafari) {
            _queueFnCall(function () {
                window.mixpanel.track(name, properties, function () {
                    if (isSafari) {
                        window.location.href = url;
                    } else {
                        window.open(url);
                    }
                });
            });
        },
        // Tidies up Audio Mode settings into a readable string
        tidyAudioString: function (audioType, tollCountries, tollFreeCountries) {
            var tidiedAudio;
            if (audioType === 'private') {
                tidiedAudio = 'Private';
            } else if (audioType === 'voip') {
                tidiedAudio = 'VOIP';
            } else if (audioType === 'pstn') {
                if (tollCountries && tollFreeCountries) {
                    tidiedAudio = 'Toll, Toll-Free';
                } else if (tollCountries) {
                    tidiedAudio = 'Toll';
                } else {
                    tidiedAudio = 'Toll-Free';
                }
            } else {
                if (tollCountries && tollFreeCountries) {
                    tidiedAudio = 'VOIP, Toll, Toll-Free';
                } else if (tollCountries) {
                    tidiedAudio = 'VOIP, Toll';
                } else {
                    tidiedAudio = 'VOIP, Toll, Toll-Free';
                }
            }
            return tidiedAudio;
        },
        tidyAudioArray: function (audioMode) {
            var tidiedAudio = '';
            _(audioMode).forEach(function (mode) {
                if (mode === 'TOLL') {
                    tidiedAudio += 'Toll, ';
                } else if (mode === 'TOLLFREE') {
                    tidiedAudio += 'Toll-Free, ';
                } else {
                    tidiedAudio = mode + ', ';
                }
            });
            // Remove trailing space and comma
            tidiedAudio = tidiedAudio.substring(0, tidiedAudio.length - 2);
            return tidiedAudio;
        }

    };
});

